module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAKRJREFUSEvN1bENAjEMBdB/UnooGYGSFSiZJfOkcJa524CWERjCUtC1FBf7Wxakz3+yY8ULks+SnI/fAr33dYxxVtVHrfXNVHtYgYg8AdwAvFT1ziCHQGvtUkpZAVxZZPoGUWQK7H2PICYggpgBFnEBDOIGvMj/Ad6JclXgDd/baQaYcDPAhpuASPgUiIZPgfTvWkQ2AKe0hcNssO875jFlsXTgA9+XoxkhNH15AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/home/more.png
// module id = 2qq7
// module chunks = 101